import { DndContext } from '@dnd-kit/core';
import Draggable from "./Draggable";
import Droppable from "./Droppable";
import useStore from "./useStore";
import {isContained, percentX, percentY} from './utils';
import { useContext, useState } from 'react';
import API from "../../../services/API";
import ToastContext from "../../../services/Context/ToastContext";
import { txt } from '../../../services/translation';

export default function Frame({settings}){

    const {items, selectItem, deselectItem, moveItem, setPicture, resetPicture} = useStore()

    const [active, setActive] = useState()

    const {setToast} = useContext(ToastContext)

    const handleItemDragStart = e => {

        selectItem(e.active.data.current.id)
    }

    const handleItemDragEnd = e => {

        if(!isContained(e.active.id)) return false;

        moveItem(e.active.data.current.id, percentX(e.delta.x), percentY(e.delta.y))
    }

    const handleFileDrop = e => {
        e.preventDefault();

        let files = e.dataTransfer.files;
        
        if(!files || !files[0]){

            return resetPicture()
        }

        let file = files[0];

        setPicture({
            url: URL.createObjectURL(file),
            name: file.name
        })

        API.upload(`/pictures`, file)
            .then(r => {
                setPicture(r.data)
            })
            .catch(_ => {
                resetPicture()
                setToast({severity: 'error', message: txt('imageTooHeavyOrWrongFormat')})
            })

        setActive(false)
    }

    const handleFileDrag = e => {
        e.preventDefault();
        setActive(true)
    }

    const handleFileDragLeave = e => {
        e.preventDefault();
        setActive(false)
    }


    return <div id="certificate-frame" 
        onDrop={handleFileDrop}
        onDragOver={handleFileDrag}
        onDragEnter={handleFileDrag}
        onDragLeave={handleFileDragLeave}
        onClick={() => deselectItem()}
        style={{
            border: 'dashed 2px', 
            borderColor: active ? 'dodgerblue': 'lightgrey',
        }}
    >
    
        <DndContext onDragStart={handleItemDragStart} onDragEnd={handleItemDragEnd}>

            <Droppable settings={settings}>

                {items.map(i => 
                    <Draggable 
                        id={`certificate-${i.id}`}
                        key={i.id}
                        item={i}
                    />    
                )}

            </Droppable>

        </DndContext> 

    </div>
}




